<div class="list-group">
  <div class="list-group-item d-flex pt-2 pb-1" *ngFor="let patient of patients">
    <div class="col-9 mr-auto">
      <h5 class="mb-0">{{patient.name}}</h5>
      <h6 class="mt-0"><strong><small><em>{{patient.dob | date:'dd/LL/yyyy'}}</em></small></strong></h6>
    </div>
    <div class="col-3 ml-auto">
        <button class="btn btn-link float-right pt-0 pb-0"
          type="button" routerLink="{{patient.id}}/agendamento/novo">
            <fa-icon class="fa-2x" [icon]="calendarAlt" data-toggle="tooltip" title="Agendar atendimento"></fa-icon>
        </button>
        <button class="btn btn-link float-right pt-0 pb-0"
          type="button" routerLink="{{patient.id}}">
            <fa-icon class="fa-2x" [icon]="addressCard" data-toggle="tooltip" title="Cadastro paciente"></fa-icon>
        </button>
        <button class="btn btn-link float-right pt-0 pb-0"
          type="button" routerLink="{{patient.id}}/atendimento"
          *ngIf="(authService.isDoctor() || authService.isAdmin())">
            <fa-icon class="fa-2x" [icon]="userMd" data-toggle="tooltip" title="Prontuário paciente"></fa-icon>
        </button>
    </div>
  </div>
</div>

